var ContentLoaderSize = {
    ExtraSmall: 'extra-small',
    Small: 'small',
    Medium: 'medium',
    Large: 'large',
};

export { ContentLoaderSize };
